import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { carrotClient } from "#/utils/CarrotClient"
import ResponseError from "#/types/responseError"
import { useMutation, UseMutationResult } from "@tanstack/react-query"

export interface TelemedicineForPelvicFloorTherapyRegistration {
  url: string
}

const REGISTER_TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY_MUTATION_KEY = ["registerTelemedicineForPelvicFloorTherapy"]

export function useRegisterTelemedicineForPelvicFloorTherapy(): UseMutationResult<
  TelemedicineForPelvicFloorTherapyRegistration,
  ResponseError,
  void
> {
  return useMutation({
    mutationKey: REGISTER_TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY_MUTATION_KEY,
    mutationFn: () => carrotClient.registerTelemedicineForPelvicFloorTherapy(),
    retry: buildCarrotApiRetryPolicy(1)
  })
}
